import { render, staticRenderFns } from "./UsageTracker.vue?vue&type=template&id=fa77c590&scoped=true"
import script from "./UsageTracker.vue?vue&type=script&lang=js"
export * from "./UsageTracker.vue?vue&type=script&lang=js"
import style0 from "./UsageTracker.vue?vue&type=style&index=0&id=fa77c590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa77c590",
  null
  
)

export default component.exports